import React, { useContext } from 'react';
import constants from '../../common/constants';
import Breadcrumbs from '../common/Breadcrumbs';
import { WorkflowTableIdentity } from '../../common/CookieRegistry';
import ContentWorkflowTableV3 from '../workflow-viewer/ContentWorkflowTableV3';
import { WorkflowActions } from '../../model/Enum';
import {
  DefaultContentSelectorOptions,
  getTechwriterTableColumns,
} from '../workflow-viewer/ContentWorkflowTableDefinitions';
import { WorkflowTableContext } from '../../contexts/WorkflowTableContext';
import { AppContext } from '../../contexts/AppContext';
import { getDefaultTechwriterQuery } from '../workflow-viewer/ContentWorkflowTableFilters';
import { extractUserAlias } from '../../api/UtilsApi';
import { AllContentsTableDataProvider } from '../content/table/AllContentsTableDataProvider';
import { useTechWriters } from '../content/table/Hooks';
import { Box } from '@amzn/awsui-components-core';

const TechWriterDashboardV3 = () => {
  const appContext = useContext(AppContext);
  const techWriterQuery = getDefaultTechwriterQuery(
    // @ts-expect-error TS18048 - strict migration
    extractUserAlias(appContext.authnInfo.userProfile.userId),
  );

  const allContentTableColumns = getTechwriterTableColumns({
    tableId: WorkflowTableIdentity.TechwriterDashboardNew,
  });
  const contentSelectorOptions = DefaultContentSelectorOptions.filter((o) =>
    allContentTableColumns.some((c) => c.id === o.id),
  );

  const breadcrumbItems = [
    { text: constants.APP_NAME_BREAD_CRUMB, href: '/' },
    { text: constants.TECH_WRITER_BREAD_CRUMB, href: '/tech-writer/dashboard-new' },
    { text: constants.DASHBOARD, href: '' },
  ];

  const allContentControlActions = [
    WorkflowActions.EDIT_CONTENT,
    WorkflowActions.EDIT_WORKFLOW,
    WorkflowActions.APG_DISTRIBUTE,
    WorkflowActions.APG_REVOKE,
    WorkflowActions.EDIT_RESOURCE_ACCESS,
    WorkflowActions.DEMOTE_AUDIENCE,
    WorkflowActions.SKIP_DRAFT_REVIEW,
    WorkflowActions.UNLOCK_WORKFLOW,
    WorkflowActions.RESTORE_PUBLISHED_CONTENT_VERSION,
  ];

  const fetchTechWritersState = useTechWriters();

  return (
    <Box variant="div" padding={{ vertical: 'l' }}>
      <Breadcrumbs items={breadcrumbItems} />
      <Box variant="h2" padding={{ horizontal: 'l' }}>
        {constants.TECH_WRITER_DASHBOARD_TITLE}
      </Box>
      <Box variant="div" padding={{ horizontal: 'l' }}>
        <WorkflowTableContext.Provider value={{ fetchTechWritersState }}>
          <ContentWorkflowTableV3
            tableId={WorkflowTableIdentity.TechwriterDashboardNew}
            header={constants.CONTENT_HEADER}
            columnDefinitions={allContentTableColumns}
            defaultQuery={techWriterQuery}
            allowedControlActions={allContentControlActions}
            showCustomFilters
            stickyColumns={{ first: 3, last: 0 }}
            tableSelectorOptions={contentSelectorOptions}
            tableDataProvider={<AllContentsTableDataProvider />}
            showRestorePreviousVersion
          />
        </WorkflowTableContext.Provider>
      </Box>
    </Box>
  );
};

export default TechWriterDashboardV3;
